<div>
	@if (showForm()) {
		@if (edit(); as edit) {
			<nz-tabs [nzSelectedIndex]="selectedTabIndex()">
				<nz-tab nzTitle="Edit Section">
					<app-setup-wizard-section-form
						[courseUuid]="(edit.after || edit.before)!.course_uuid!"
						[loading]="loading()"
						[edit]="edit.after || edit.before || null"
						(onClear)="onFormClear()"
						(onSubmit)="onFormSubmit($event)"
					></app-setup-wizard-section-form>
				</nz-tab>
				<nz-tab nzTitle="Section Enrollment">
					<app-setup-wizard-users-table
						[enableEditButton]="false"
						[enableToggleDisableButton]="false"
						[enableRemoveButton]="false"
						[enableResetButton]="false"
						[enableEnrollButton]="true"
						[enableUnenrollButton]="true"
						[pageSize]="2"
						[columnsFilter]="userTableColumns()"
						[selectedSection]="edit"
						(onEnroll)="onEnroll($event)"
						(onUnenroll)="onUnenroll($event)"
					></app-setup-wizard-users-table>
				</nz-tab>
			</nz-tabs>
		} @else {
			<h1>Edit is missing...</h1>
		}
	} @else {
		<div class="top-buttons">
			<button
				nz-button
				nzType="primary"
				(click)="onAdd()"
				class="add-button"
				[disabled]="true"
				nz-tooltip="To add a new section go to the course tab and edit the course you want to add the section to."
			>
				Add
			</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.sections"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-sections-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onEditUsers)="onEditUsers($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-sections-table>
</div>
